/*
 * @Author: your name
 * @Date: 2019-06-18 21:41:32
 * @LastEditTime: 2019-11-11 09:36:52
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \source\src\components\onlineMap\sideBar\UCSideBarJs.js
 */
export const UCModuleItemType=
{   
    poiResult:"poiResult",

    routeline:"routeline",

    userCollect:"userCollect",

}